var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "service-autocomplete",
    _vm._b(
      {
        ref: "autocomplete",
        attrs: {
          "search-attributes-array": ["id", "name", "short_name"],
          value: _vm.value,
          url: _vm.url,
          "cache-items": "",
          "use-entities": _vm.useEntities,
          "id-field": _vm.idField,
          "nav-full-id-field": "nav_full_id",
          dense: "",
          multiple: "",
          outlined: "",
          label: _vm.generateMessage("boilerplate.filters.entity")
        },
        on: {
          input: _vm.handleInputChange,
          "clear-items": function($event) {
            return _vm.$emit("clear-items")
          }
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function({ item }) {
              return [
                _vm._v(
                  "\n    " + _vm._s(item.id + " - " + item.short_name) + "\n  "
                )
              ]
            }
          },
          {
            key: "selection",
            fn: function(data) {
              return [
                _c(
                  "v-chip",
                  _vm._b(
                    {
                      attrs: { value: data.selected, close: "", small: "" },
                      on: {
                        "click:close": function($event) {
                          return _vm.$refs.autocomplete.handleInputRemove(
                            data.item
                          )
                        }
                      }
                    },
                    "v-chip",
                    data.attrs,
                    false
                  ),
                  [_vm._v("\n      " + _vm._s(data.item.id) + "\n    ")]
                )
              ]
            }
          }
        ])
      },
      "service-autocomplete",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }